module.exports = __webpack_public_path__ + "img/frente.99532452.png";